import React from "react";

import { defineMessages, useIntl } from "react-intl";

import { Alert } from "@mapmycustomers/ui";

import Scoped from "@app/scene/dashboard/types/Scoped";

const messages = defineMessages({
  alert: {
    id: "dashboard.editModal.dateRange.noRange",
    defaultMessage:
      "Time Range cannot be applied to charts of this type. Any records that are currently out of frequency (past due) and meet the above criteria will be included.",
    description:
      "Alert shown when Card has no applicable time range in Edit Card Modal on Dashboard",
  },
});

interface Props extends Scoped {}

const NoTimeRangeFormComponent: React.FC<Props> = () => {
  const intl = useIntl();
  return <Alert message={intl.formatMessage(messages.alert)} type="info" />;
};

export default NoTimeRangeFormComponent;
